module.exports = __webpack_public_path__ + "static/media/Moving_van.b89e5824.svg";